/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function RoleReader({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M6.155 2.831a2.543 2.543 0 0 0-4.808.776L.405 10.67a.601.601 0 0 0 0 .151A3.729 3.729 0 0 0 .4 11c0 1.972 1.559 3.6 3.517 3.6s3.516-1.628 3.516-3.6c0-.335-.045-.66-.13-.97.16-.138.41-.23.697-.23.288 0 .538.092.697.23-.085.31-.13.635-.13.97 0 1.972 1.559 3.6 3.517 3.6S15.6 12.972 15.6 11c0-.06-.002-.121-.005-.181a.602.602 0 0 0-.001-.148l-.942-7.064a2.543 2.543 0 0 0-4.808-.776l-.051.107a.6.6 0 0 0 1.079.524l.052-.106a1.343 1.343 0 0 1 2.538.41l.565 4.233a3.439 3.439 0 0 0-1.944-.599c-1.194 0-2.24.605-2.874 1.525A2.353 2.353 0 0 0 8 8.6c-.408 0-.84.1-1.21.325A3.483 3.483 0 0 0 3.917 7.4c-.722 0-1.39.221-1.945.6l.565-4.235a1.343 1.343 0 0 1 2.538-.41l.052.107a.6.6 0 1 0 1.08-.524l-.052-.107ZM3.917 8.6C2.653 8.6 1.6 9.658 1.6 11c0 1.342 1.053 2.4 2.317 2.4 1.263 0 2.316-1.058 2.316-2.4 0-1.342-1.053-2.4-2.316-2.4Zm8.167 0c-1.264 0-2.317 1.058-2.317 2.4 0 1.342 1.053 2.4 2.317 2.4 1.264 0 2.317-1.058 2.317-2.4 0-1.342-1.053-2.4-2.317-2.4Z" clipRule="evenodd" /></svg>;
}
;